<section class="contact-us-title">
    <div class="container">
        <h1 class="section-title">Contact us</h1>
        <p>Have a question or some feedback? Just feeling loved up and need to gush to someone? We'd love to hear from
            you.</p>
    </div>
</section>

<section class="contact-us-wrap">
    <div class="container">
        <div class="contact-us-inner">
            <a [routerLink]="['/'+ routesConstants.SIGN_UP_NAVIGATION]" class="secondary-btn">
                <span><i>🏡</i> List your venue</span>
                <img [src]="imagePathConstants.GENERAL + '/arrow-right-icon.svg'" width="13" height="10" alt="Right arrow icon" loading="lazy">
            </a>
            <a [routerLink]="['/'+ routesConstants.SIGN_UP_NAVIGATION]" [fragment]="'service'" class="secondary-btn">
                <span><i>💐</i> Join our Vendor Directory</span>
                <img [src]="imagePathConstants.GENERAL + '/arrow-right-icon.svg'" width="13" height="10" alt="Right arrow icon" loading="lazy">
            </a>
            <a [routerLink]="['/'+ routesConstants.HUB_NAVIGATION]" type="button" class="secondary-btn">
                <span><i>❤️</i> Create your couples profile</span>
                <img [src]="imagePathConstants.GENERAL + '/arrow-right-icon.svg'" width="13" height="10" alt="Right arrow icon" loading="lazy">
            </a>
            <a [routerLink]="['/'+ routesConstants.HOW_IT_WORKS_FAQS_NAVIGATION]" class="secondary-btn">
                <span><i>👀</i> Check our FAQs</span>
                <img [src]="imagePathConstants.GENERAL + '/arrow-right-icon.svg'" width="13" height="10" alt="Right arrow icon" loading="lazy">
            </a>
            <a [routerLink]="['/'+ routesConstants.SUBMIT_WEDDING]" class="secondary-btn">
                <span><i>💍</i> Submit a Real Wedding</span>
                <img [src]="imagePathConstants.GENERAL + '/arrow-right-icon.svg'" width="13" height="10" alt="Right arrow icon" loading="lazy">
            </a>
            <a [routerLink]="['/'+ routesConstants.GET_IN_TOUCH]" class="secondary-btn">
                <span><i>👋</i> Get in touch</span>
                <img [src]="imagePathConstants.GENERAL + '/arrow-right-icon.svg'" width="13" height="10" alt="Right arrow icon" loading="lazy">
            </a>
        </div>
    </div>
</section>

<!--FAQs section-->
<app-faq-cta></app-faq-cta>

<!--Wedding Planning section-->
<app-wedding-plan-cta></app-wedding-plan-cta>
